import BaseSettingsPage from "@settings/base/BaseSettingsPage";


export const ProjectDetailsSettingsPage = () => {
  return <BaseSettingsPage title="Projekt Details" />
}